import { schema } from 'normalizr';
import { Project } from 'api/project';
import { Task as TaskApi } from 'api/tasks';
import { NormalizedData, SchemaKeys } from 'data/core';
import { dataNormalizer } from 'data/core/utils';
import { projectSchema } from 'data/projects/schema';

const taskSchema = new schema.Entity<TaskApi>(
  SchemaKeys.Tasks,
  {},
  {
    idAttribute: 'taskId',
  },
);

taskSchema.define({
  subTasks: [taskSchema],
  project: projectSchema,
});

export { taskSchema };

export interface Task
  extends Omit<TaskApi, 'subTasks' | 'dependentTasks' | 'project'> {
  subTasks: number[];
  dependentTasks: Task[];
  project: number;
  parentTask?: number;
}

export interface RecordDataTask extends Task {
  projectId: number;
  id: number;
}

type TaskEntities = {
  tasks: NormalizedData<Task>;
  projects: NormalizedData<Project>;
};

export const taskNormalizer = (data: TaskApi | TaskApi[]) =>
  dataNormalizer<Task, TaskEntities, TaskApi>(data, taskSchema);
